import { Button, DatePicker, Divider, Form, Radio, Select } from 'antd';
import { filter, map } from 'lodash';
import React, { useEffect } from 'react';
import {
  DATE_FORMATS,
  ORDER_STATUS,
  PLAN_NAMES_OPTIONS,
  PLAN_TYPES_OPTIONS,
  USER_FORM_STATUS,
} from '../../../../../common/constants';
import ModalComponent from '../../../../../components/ModalComponent';
import SelectComponent from '../../../../../components/SelectComponent';
import LibrarySelect from '../../transfer/components/LibrarySelect';

const { Item } = Form;
const { RangePicker } = DatePicker;
const { Group } = Radio;

const AllUsersFilterModal = ({
  isModalOpen,
  setIsModalOpen,
  onFinish,
  finalWhereFilters,
  setFinalWhereFilters,
  isNewPath,
}) => {
  const [form] = Form.useForm();

  const handleReset = () => {
    setIsModalOpen(false);
    form?.resetFields();
    setFinalWhereFilters();
    form?.submit();
  };

  const { Option } = Select;

  useEffect(() => {
    form?.setFieldsValue({
      ...finalWhereFilters,
      createdAt: [
        finalWhereFilters?.createdAt?.from,
        finalWhereFilters?.createdAt?.to,
      ],
      deliveredOn: [
        finalWhereFilters?.deliveredOn?.from,
        finalWhereFilters?.deliveredOn?.to,
      ],
      status: finalWhereFilters?.status,
      deliveryType: finalWhereFilters?.deliveryType,
      pincodes: finalWhereFilters?.pincodes,
    });
  }, [isModalOpen]);

  const orderStatus = isNewPath
    ? map(
        filter(
          ORDER_STATUS,
          (item) =>
            item?.value === ORDER_STATUS?.PLACED?.value ||
            item?.value === ORDER_STATUS?.CONFIRMED?.value,
        ),
        (item) => ({ label: item?.text, value: item?.value }),
      )
    : map(ORDER_STATUS, (item) => ({ label: item?.text, value: item?.value }));

  return (
    <>
      <ModalComponent
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        title="Filter"
        forceRender
        destroyOnClose
        footer={null}
      >
        <Divider />
        <div className="mb-16">
          <Form
            form={form}
            onFinish={onFinish}
            autoComplete="off"
            layout="vertical"
          >
            <Item label="Status" name="status">
              <SelectComponent showSearch={false} placeholder="Select status">
                {USER_FORM_STATUS?.map((option) => (
                  <Option key={option?.value} value={option?.value}>
                    {option?.label}
                  </Option>
                ))}
              </SelectComponent>
            </Item>
            <Item label="Billing Cycle" name="billingCycle">
              <SelectComponent
                showSearch={false}
                placeholder="Select Billing Cycle"
                mode="multiple"
                maxTagCount={false}
              >
                {PLAN_TYPES_OPTIONS?.map((option) => (
                  <Option key={option?.value} value={option?.value}>
                    {option?.label}
                  </Option>
                ))}
              </SelectComponent>
            </Item>

            <Item label="Plan Subscribed" name="planSubscribed">
              <SelectComponent
                showSearch={false}
                placeholder="plan Subscribed"
                mode="multiple"
                maxTagCount={false}
              >
                {PLAN_NAMES_OPTIONS?.map((option) => (
                  <Option key={option?.value} value={option?.value}>
                    {option?.label}
                  </Option>
                ))}
              </SelectComponent>
            </Item>
            <Item label="User since" name="createdAt">
              <RangePicker
                format={DATE_FORMATS?.REGULAR}
                className="full-width"
                popupClassName="picker-with-scroll"
                placeholder={['From Date', 'To Date']}
                value={
                  finalWhereFilters?.createdAt?.from
                    ? [
                        finalWhereFilters?.createdAt?.from,
                        finalWhereFilters?.createdAt?.to,
                      ]
                    : null
                }
              />
            </Item>

            <Item label="Primary mapped library" name="name">
              <LibrarySelect />
            </Item>
          </Form>
          <div className="d-flex justify-end">
            <Button htmlType="submit" onClick={handleReset} className="mr-8">
              Reset
            </Button>
            <Button key="submit" type="primary" onClick={form?.submit}>
              Apply
            </Button>
          </div>
        </div>
      </ModalComponent>
    </>
  );
};

export default AllUsersFilterModal;
